const getTimeString = (dateTimeString: string): string => {
  const dateTime = new Date(dateTimeString);

  return dateTime.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' });
};

export default getTimeString;
